// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
import dayjs from '/app/node_modules/.pnpm/dayjs@1.11.18/node_modules/dayjs';
import antdPlugin from '/app/node_modules/.pnpm/antd-dayjs-webpack-plugin@1.0.6_dayjs@1.11.18/node_modules/antd-dayjs-webpack-plugin/src/antd-plugin.js';

import isSameOrBefore from '/app/node_modules/.pnpm/dayjs@1.11.18/node_modules/dayjs/plugin/isSameOrBefore';
import isSameOrAfter from '/app/node_modules/.pnpm/dayjs@1.11.18/node_modules/dayjs/plugin/isSameOrAfter';
import advancedFormat from '/app/node_modules/.pnpm/dayjs@1.11.18/node_modules/dayjs/plugin/advancedFormat';
import customParseFormat from '/app/node_modules/.pnpm/dayjs@1.11.18/node_modules/dayjs/plugin/customParseFormat';
import weekday from '/app/node_modules/.pnpm/dayjs@1.11.18/node_modules/dayjs/plugin/weekday';
import weekYear from '/app/node_modules/.pnpm/dayjs@1.11.18/node_modules/dayjs/plugin/weekYear';
import weekOfYear from '/app/node_modules/.pnpm/dayjs@1.11.18/node_modules/dayjs/plugin/weekOfYear';
import isMoment from '/app/node_modules/.pnpm/dayjs@1.11.18/node_modules/dayjs/plugin/isMoment';
import localeData from '/app/node_modules/.pnpm/dayjs@1.11.18/node_modules/dayjs/plugin/localeData';
import localizedFormat from '/app/node_modules/.pnpm/dayjs@1.11.18/node_modules/dayjs/plugin/localizedFormat';
import duration from '/app/node_modules/.pnpm/dayjs@1.11.18/node_modules/dayjs/plugin/duration';

dayjs.extend(isSameOrBefore);
dayjs.extend(isSameOrAfter);
dayjs.extend(advancedFormat);
dayjs.extend(customParseFormat);
dayjs.extend(weekday);
dayjs.extend(weekYear);
dayjs.extend(weekOfYear);
dayjs.extend(isMoment);
dayjs.extend(localeData);
dayjs.extend(localizedFormat);
dayjs.extend(duration);

dayjs.extend(antdPlugin);
